import type { Action } from '@reduxjs/toolkit';

import type { GetState, ThunkDispatchType } from 'app/redux/types';

import { API, getAsyncThunk } from 'app/api';
import { clientId as selectClientId } from 'app/lib/account/selectors';

import { getBigCashOutErrors } from '../utils/big-cash-out-storage';

// ---

export type AutoUpdateActiveStakes = ReturnType<typeof autoUpdateActiveStakes.fulfilled>;

export const autoUpdateActiveStakes = getAsyncThunk(
  'MY_STAKES:AUTO_UPDATE_ACTIVE_STAKES',
  API.myStakes.fetchActiveStakes,
);

export type FetchActiveStakes = ReturnType<typeof fetchActiveStakesService.fulfilled>;

export const fetchActiveStakesService = getAsyncThunk(
  'MY_STAKES:FETCH_ACTIVE_STAKES',
  API.myStakes.fetchActiveStakes,
);

export const fetchActiveStakes = () => (
  (dispatch: ThunkDispatchType, getState: GetState) => {
    const state = getState();
    const clientId = selectClientId(state);
    const savedCashOutErrors = clientId ? getBigCashOutErrors(clientId) : null;

    return dispatch(fetchActiveStakesService(savedCashOutErrors));
  }
);

// ---

export const TOGGLE_AUTO_UPDATE = 'MY_STAKES:TOGGLE_AUTO_UPDATE';

export type ToggleAutoUpdate = Action<typeof TOGGLE_AUTO_UPDATE>;

export const toggleAutoUpdate = () => ({ type: TOGGLE_AUTO_UPDATE });

// ---

export const CLEANUP_ACTIVE_STAKES = 'MY_STAKES:CLEANUP_ACTIVE_STAKES';

export type CleanupActiveStakes = Action<typeof CLEANUP_ACTIVE_STAKES>;

export const cleanupActiveStakes = (): CleanupActiveStakes => ({ type: CLEANUP_ACTIVE_STAKES });
